import { render, staticRenderFns } from "./Visa.vue?vue&type=template&id=23df9fec"
import script from "./Visa.vue?vue&type=script&lang=js"
export * from "./Visa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports